import { ReactNode } from 'react';
import { Spinner } from '@weareopenr/component-library';
import { SpinnerContainer } from 'src/components/SpinnerContainer';

interface LoaderProps {
  loading: boolean;
  fallback?: ReactNode;
  children: ReactNode | (() => ReactNode);
}

export const Loader = ({ loading, fallback, children }: LoaderProps) => {
  if (loading) {
    return (
      <>
        {fallback ?? (
          <SpinnerContainer data-testid="loadingIcon">
            <Spinner size="xlarge" colour="rainbow" />
          </SpinnerContainer>
        )}
      </>
    );
  }

  return <>{typeof children === 'function' ? children() : children}</>;
};
